/* eslint-disable no-undef */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import PostAddIcon from "@mui/icons-material/PostAdd";
import AddIcon from "@mui/icons-material/Add";
import VisibilityIcon from "@mui/icons-material/Visibility";
import LeaderboardIcon from "@mui/icons-material/Leaderboard";
import SettingsIcon from "@mui/icons-material/Settings";
import useAxiosPrivate from "contexts/interceptors/axios";
import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Paper,
  Tooltip,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";
import { useStateContext } from "../../../../../contexts/ContextProvider";
import AddPostModal from "../../../../../modals/i-abide/CreatePost";
import ViewPostModal from "../../../../../modals/i-abide/ViewPostModal";
import SubmissionModal from "../../../../../modals/i-abide/SubmissionsModal";

export default function Posts() {
  const [viewPostId, setViewPostId] = useState(null);
  const [subPostId, setSubPostId] = useState(null);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [openSubmissionsModal, setOpenSubmissionsModal] = useState(false);
  const [data, setData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const axiosPrivate = useAxiosPrivate();
  const { auth } = useStateContext();

  const handleGetAll = () => {
    // Initialize loading state and clear any previous error
    setLoading(true);
    setError("");

    axiosPrivate
      .get(`/I-Abide/getAllPosts`)
      .then((response) => {
        // Initialize postsData with the fetched data or an empty array if no data
        let postsData = response?.data?.data || [];

        // Filter posts if the role is "cid - eps" based on posted_by matching the auth username
        if (
          auth?.role === "education program supervisor" ||
          auth?.role === "education program specialist 2" ||
          auth?.role === "senior education program specialist" ||
          auth?.role === "chief education supervisor" ||
          auth?.role === "accountant 3" ||
          auth?.role === "project development officer 1" ||
          auth?.role === "project development officer 2" ||
          auth?.role === "administrative officer 2" ||
          auth?.role === "administrative officer 4" ||
          auth?.role === "administrative officer 5"
        ) {
          postsData = postsData.filter(
            (post) => post?.posted_by === auth?.username
          );
        } else {
          console.log("No filtering applied for role:", auth?.role);
        }

        // Handle case where no posts are available after filtering
        if (postsData.length === 0) {
          console.log(
            "No posts data available after filtering. Setting empty data."
          );
          setData([]); // Set empty data array
          return; // Exit the function early
        }

        // Sort the posts by deadline in descending order and set the sorted data
        const sortedPosts = postsData.sort(
          (a, b) => new Date(b.posting_date) - new Date(a.posting_date)
        );
        setData(sortedPosts);
      })
      .catch((error) => {
        // Set error and log it for debugging
        setError(error);
        console.error("Error fetching posts data:", error);
      })
      .finally(() => {
        // Turn off loading state
        setLoading(false);
      });
  };

  useEffect(() => {
    handleGetAll();
  }, []);

  const handleView = (postId) => {
    setViewPostId(postId);
    setOpenViewModal(true);
  };

  const handleViewSubmissions = (postId) => {
    setSubPostId(postId);
    setOpenSubmissionsModal(true);
  };

  return (
    <Box p={1}>
      <Box sx={{ p: 2, background: "black" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            textAlign: "center",
            gap: 2,
          }}
        >
          <PostAddIcon style={{ fontSize: 50, color: "#ecfc08" }} />
          <Typography
            variant="h5"
            sx={{
              fontFamily: "Poppins",
              fontWeight: "bold",
              color: "white",
            }}
          >
            POSTS
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", p: 1 }}>
        <Box display="flex" justifyContent="flex-end">
          <Button
            variant="outlined"
            color="primary"
            endIcon={<AddIcon />}
            sx={{
              fontSize: "1.2rem",
              padding: "12px 24px",
              minWidth: "180px",
              "&:hover": {
                backgroundColor: "#007BFF",
                borderColor: "#0056b3",
                color: "#fff",
              },
            }}
            onClick={() => setOpenModal(true)}
          >
            CREATE POST
          </Button>
        </Box>
      </Box>

      {loading && <CircularProgress />}
      {error && <Typography color="error">{error}</Typography>}

      <Box>
        {data.length > 0 ? (
          <List>
            {data.map((post) => (
              <ListItem key={post.id}>
                <Paper elevation={3} sx={{ p: 2, width: "100%" }}>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Box>
                      <Typography variant="h6">{post.post_title}</Typography>
                      <Box sx={{ display: "flex", gap: 2 }}>
                        <Typography>DUE: </Typography>
                        <Typography>
                          {dayjs(post.deadline).format("MMMM D, YYYY h:mm A")}
                        </Typography>
                        {auth?.role !== "admin" ? (
                          <Typography
                            sx={{ fontFamily: "Poppins", fontWeight: "bold" }}
                          >
                            {post.status}
                          </Typography>
                        ) : null}
                      </Box>
                    </Box>

                    {/* Icons on the Right */}
                    <Box display="flex" gap={1}>
                      {/* View Tooltip */}
                      <Tooltip title="View" arrow>
                        <IconButton
                          onClick={() => handleView(post.id)}
                          sx={{ color: "#2e3887" }}
                        >
                          <VisibilityIcon />
                        </IconButton>
                      </Tooltip>

                      {/* Submissions Tooltip */}
                      {(auth?.role === "admin" ||
                        auth?.role === "education program supervisor" ||
                        auth?.role === "education program specialist 2" ||
                        auth?.role === "senior education program specialist" ||
                        auth?.role === "chief education supervisor" ||
                        auth?.role === "accountant 3" ||
                        auth?.role === "project development officer 1" ||
                        auth?.role === "project development officer 2" ||
                        auth?.role === "administrative officer 2" ||
                        auth?.role === "administrative officer 4" ||
                        auth?.role === "administrative officer 5" ||
                        auth?.role === "cid - chief" ||
                        auth?.role === "osds" ||
                        auth?.role === "asds") && (
                        <Tooltip title="Submissions" arrow>
                          <IconButton
                            onClick={() => handleViewSubmissions(post.id)}
                            sx={{ color: "red" }}
                          >
                            <LeaderboardIcon />
                          </IconButton>
                        </Tooltip>
                      )}

                      {/* Options Tooltip */}
                      {/* {auth?.role === "admin" && (
                        <Tooltip title="Options" arrow>
                          <IconButton
                            onClick={() => handleOptions(post.id)}
                            sx={{ color: "black" }}
                          >
                            <SettingsIcon />
                          </IconButton>
                        </Tooltip>
                      )} */}
                    </Box>
                  </Box>
                </Paper>
              </ListItem>
            ))}
          </List>
        ) : (
          !loading && <Typography>No posts available.</Typography>
        )}
      </Box>

      <AddPostModal open={openModal} handleClose={() => setOpenModal(false)} />
      <ViewPostModal
        open={openViewModal}
        handleClose={() => setOpenViewModal(false)}
        postId={viewPostId}
      />
      <SubmissionModal
        open={openSubmissionsModal}
        handleClose={() => setOpenSubmissionsModal(false)}
        postId={subPostId}
      />
    </Box>
  );
}
